import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faChevronLeft, faChevronRight, faFilter, faFilterCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { apiService } from '../../../services/apiService';
import Box from '@mui/material/Box';
import { MenuItem, TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TaskTabs from '../../../components/common/TaskTabs';
import dayjs from 'dayjs';
import { Modal } from 'react-bootstrap';
// const profileImage = require('../../../assets/defaultprofile.svg').default;
function RaisedCasesSeekers() {
    const navigate = useNavigate();
    const [myrequests, setMyRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingApply, setLoadingApply] = useState(false);
    const [searchParams] = useSearchParams();
    const onboarding = searchParams.get("onboarding");
    const [selectedCase, setSelectCase] = useState(onboarding ? "onboarding" : "general");
    const [isGridVisible, setGridVisible] = useState(false);

    const toggleGrid = () => {
        setGridVisible((prev) => !prev);
    };
    

    // Tableview with filter
    const [paginatedata, setPaginateData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedRecord, setShowRecord] = useState(20);
    const [loadingPage, setLoadingPage] = useState(false);
    const [applyFilData, setApplyfilData] = useState([])

    const fetchRoots = useCallback(async (params = {}) => {
        setLoadingApply(true);
        try {
            const defaultParams = { case_type: selectedCase, case_scope: "raised", ...params};
            const response = await apiService.postRequest(`/my-cases`, defaultParams);
            if(response.success === true){
                setMyRequests(response.data);
                setPaginateData(response.meta);
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching tab data:', error);
        } finally {
            setLoading(false);
            setLoadingApply(false);
            setLoadingPage(false);
        }
    }, [selectedCase]);

    const handleSearchTable = () => {
        setApplyfilData(filters);
        fetchRoots({ filters });
        setCurrentPage(1);
    };

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        fetchRoots({ page: newPage, filters: applyFilData });
        setLoadingPage(true);
    };

    useEffect(() => {
        fetchRoots();
    }, [fetchRoots]);

    const [filters, setFilters] = useState([{ logic: 'and', column: 'formatted_id', operator: 'contains', value: '' }]);

    const combineOptions = [
        { value: 'and', label: 'And' },
        { value: 'or', label: 'Or' },
    ];
    
    const rows = myrequests.map((datas) => ({
        id: datas.id,
        gCaseData: datas.gcase_summary,
        formatid: datas.format_id,

        gCaseDescription: datas?.gcase_summary?.short_description,
        gCaseCaseType: datas?.gcase_summary?.case_type,
        gCaseCaseSubType: datas?.gcase_summary?.case_sub_type,
        gCaseBusinessEntity: datas?.gcase_summary?.business_entity,
        gCaseOwnershipGroup: datas?.gcase_summary?.ownership_group,
        gCaseSolution: datas?.gcase_summary?.solution,

        requestedFor : datas.requested_for,
        requestedBy : datas.requested_by,
        assignmentGroup : datas.assignment_group || "N/A",
        assignedTo : datas.assigned_to || "N/A",
        status: datas.status,
        stage: datas.stage,
        subStage: datas.sub_stage,
        createdOn: datas.created_at,
        created_by: datas.jobseeker.name,
        onboardSlug: datas.onboarding_slug,
        taskId: datas.task_id,
        casetaskTaskLink: datas.case_task_link || "",
        requestType: datas.user_request_type,
        type: datas.type,
        onboardUserId: datas.jobseeker_id,
    }));
    

    const handleFilterChange = (index, field, value) => {
        const updated = [...filters];
        if (field === "column") {
            updated[index][field] = value;
            if (value === "created_on") {
                updated[index].operator = "range";
                updated[index].value = "today";
            } else {
                updated[index].operator = "contains";
                updated[index].value = "";
            }
            delete updated[index].start_date;
            delete updated[index].end_date;
        } else if (field === "value") {
            updated[index].value = value;
            if (value !== "custom") {
                delete updated[index].start_date;
                delete updated[index].end_date;
            }
        } else {
            updated[index][field] = value;
        }

        setFilters(updated);
    };

    const addFilter = () => {
        setFilters([...filters, { logic: 'and', column: 'formatted_id', operator: 'contains', value: '' }]);
    };

    const removeFilter = (index) => {
        setFilters(filters.filter((_, i) => i !== index));
    };
    
    const operatorOptions = [
        { value: 'contains', label: 'Contains' },
        { value: 'does_not_contain', label: 'Does Not Contain' },
        { value: 'starts_with', label: 'Starts With' },
        { value: 'ends_with', label: 'Ends With' },
        { value: 'is', label: 'Is' },
        { value: 'is_not', label: 'Is Not' },
        { value: 'is_empty', label: 'Is Empty' },
        { value: 'is_not_empty', label: 'Is Not Empty' },
    ];
    const getOperatorOptions = (column) => {
        if (column === 'created_on') {
            return [
                { value: 'range', label: 'Range' },
            ];
        }
        return operatorOptions; // Default options
    };
    

    const columns = [
        {
            field: 'formatid',
            headerName: 'ID',
            width: 200,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    {params.row.casetaskTaskLink !== "" && params.row.casetaskTaskLink !== null ?
                        <>
                        {params.row.type === "case_management" ? 
                            <Link className='case_dataspan' target='_blank' to={`${params.row.casetaskTaskLink}`}>{params.row.formatid}</Link>:
                            <Link className='case_dataspan' target='_blank' to={`${params.row.casetaskTaskLink}`}>{params.row.formatid}</Link>
                        }
                        </>:
                        <span className='case_dataspan'>{params.row.formatid}</span>
                    }
                    
                </div>
            ),
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 300,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span className={params.row.status === "Pending" ? "stautuspending" : params.row.status === "Closed" ? "stautusclosed" : "stautusprocess"}>{params.row.status}</span>
                </div>
            )
        },
        {
            field: 'stage',
            headerName: 'Stage',
            width: 350,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>{params.row.stage}</span>
                </div>
            ),
        },
        {
            field: 'subStage',
            headerName: 'Sub Stage',
            width: 350,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>{params.row.subStage}</span>
                </div>
            ),
        },
        ...((selectedCase !== 'onboarding')
        ? [{
            field: 'gCaseDescription',
            headerName: 'Short Description',
            width: 300,
            filterable: true,
            renderCell: (params) => (
            <div className='d-flex align-items-center h-100'>
                {params.row.gCaseDescription !== "N/A" ?
                <button className='hisconten_view_btn' onClick={() => handleShow(params.row.gCaseDescription || 'N/A')}>View</button>:
                <span>{params.row.gCaseDescription}</span>}
            </div>
            ),
        }]
        : []),
        {
            field: 'assignmentGroup',
            headerName: 'Assignment Group',
            width: 300,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>{params.row.assignmentGroup}</span>
                </div>
            ),
        },
        {
            field: 'assignedTo',
            headerName: 'Assigned To',
            width: 300,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>{params.row.assignedTo}</span>
                </div>
            ),
        },
        {
            field: 'requestedBy',
            headerName: 'Requested By',
            width: 250,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>{params.row.requestedBy}</span>
                </div>
            ),
        },
        {
            field: 'requestedFor',
            headerName: 'Requested For',
            width: 250,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>{params.row.requestedFor}</span>
                </div>
            ),
        },
        {
            field: 'createdOn',
            headerName: 'Created On',
            width: 200,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>{params.row.createdOn}</span>
                </div>
            )
        },
        ...((selectedCase === 'onboarding')
        ? [{
            field: 'created_by',
            headerName: 'Jobseeker',
            width: 300,
            filterable: true,
            renderCell: (params) => (
            <div className='d-flex align-items-center h-100'>
                <span>{params.row.created_by}</span>
            </div>
            ),
        }]
        : []),
    ];

    const [show, setShow] = useState(false);
    const [modalData, setModalData] = useState(null);
    
    const handleClose = () => setShow(false);
    
    const handleShow = (data) => {
        setModalData(data);
        setShow(true);
    };
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container className="main_jobseeker">
                <Grid size={{xs:12}} container alignItems="center">
                    <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>Task</h3>
                        <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Task <FontAwesomeIcon className='angleright' icon={faAngleRight} /> My Cases</span>
                    </Grid>
                    <Grid size={{md:12,xs:12}} container justifyContent="space-between" className="statusselectbtn my-4">
                        <Grid size={{sm:12,xs:12}} container>
                            <TaskTabs/>
                        </Grid>
                    </Grid>
                </Grid>
                {loading ? 
                    <div className='d-flex justify-content-center w-100'>
                        <img style={{ width: "100px" }} src={require('../../../assets/pinkloader.gif')} alt='Loading...' />
                    </div> :<>
                    <Box sx={{width:"100%"}} className="datatable_jobpagi">
                        {isGridVisible && (
                        <Box sx={{ mb: 2 }} className="my-4">
                            {filters.map((filter, index) => (
                                <Box key={index} className="d-flex align-items-start flex-wrap">
                                    {index > 0 && (
                                        <select
                                            label="Combine"
                                            value={filter.logic}
                                            onChange={(e) => handleFilterChange(index, 'logic', e.target.value)}
                                            sx={{ mr: 1, minWidth: 80,mb:1 }}
                                        >
                                            {combineOptions.map((option) => (
                                                <option key={option.value} value={option.value}>{option.label}</option>
                                            ))}
                                        </select>
                                    )}
                                    <TextField
                                        select
                                        label="Column"
                                        value={filter.column}
                                        onChange={(e) => handleFilterChange(index, 'column', e.target.value)}
                                        sx={{ mr: 1, minWidth: 120,mb:1 }}
                                    >
                                        <MenuItem value="formatted_id">ID</MenuItem>
                                        <MenuItem value="status">Status</MenuItem>
                                        <MenuItem value="stage">Stage</MenuItem>
                                        <MenuItem value="sub_stage">Sub Stage</MenuItem>
                                        {selectedCase === "general" &&
                                            <MenuItem value="short_description">Short Description</MenuItem>
                                        }
                                        <MenuItem value="assignment_group">Assignment Group</MenuItem>
                                        <MenuItem value="assigned_to">Assigned To</MenuItem>
                                        <MenuItem value="requested_by">Requested By</MenuItem>
                                        <MenuItem value="requested_for">Requested For</MenuItem>
                                        <MenuItem value="created_on">Created On</MenuItem>
                                        {selectedCase !== "general" &&
                                            <MenuItem value="jobseeker">Jobseeker</MenuItem>
                                        }
                                    </TextField>
                                    <TextField
                                        select
                                        label="Operator"
                                        value={filter.operator}
                                        onChange={(e) => handleFilterChange(index, 'operator', e.target.value)}
                                        sx={{ mr: 1, minWidth: 120,mb:1 }}
                                    >
                                        {getOperatorOptions(filter.column).map((option) => (
                                            <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                                        ))}
                                    </TextField>
                                    {filter.operator === "is_not_empty" || filter.operator === "is_empty" ? "" :<>
                                        {filter.column === 'status' ? (
                                            <select
                                                label="Value"
                                                value={filter.value}
                                                onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
                                                sx={{ mr: 1, minWidth: 120,mb:1 }}
                                            >
                                                <option value="" disabled>Select Status</option>
                                                <option value="In-progress">In-progress</option>
                                                <option value="Completed">Completed</option>
                                                <option value="New">New</option>
                                                <option value="Rejected">Rejected</option>
                                            </select>
                                        ) : (filter.column === 'created_on') ? (
                                            <Box sx={{ display: 'flex', gap: 1 }}>
                                                <TextField
                                                    select
                                                    label="Value"
                                                    value={filter.value || "today"}
                                                    onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
                                                    sx={{ minWidth: 120,mb:1 }}
                                                >
                                                    <MenuItem value="today">Today</MenuItem>
                                                    <MenuItem value="yesterday">Yesterday</MenuItem>
                                                    <MenuItem value="this_week">This Week</MenuItem>
                                                    <MenuItem value="last_week">Last Week</MenuItem>
                                                    <MenuItem value="this_month">This Month</MenuItem>
                                                    <MenuItem value="last_month">Last Month</MenuItem>
                                                    <MenuItem value="last_3_months">Last 3 Months</MenuItem>
                                                    <MenuItem value="custom">Custom</MenuItem>
                                                </TextField>
                                                {filter.value === "custom" &&
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker 
                                                        className="filterrages mb-2"
                                                        label="Start Date"
                                                        value={filter.start_date ? dayjs(filter.start_date) : null}
                                                        onChange={(newValue) =>
                                                            handleFilterChange(
                                                            index,
                                                            "start_date",
                                                            newValue ? newValue.format("YYYY-MM-DD") : null
                                                            )
                                                        }
                                                        />

                                                        <DatePicker
                                                        label="End Date"
                                                        className="filterrages mb-2 me-2"
                                                        value={filter.end_date ? dayjs(filter.end_date) : null}
                                                        onChange={(newValue) =>
                                                            handleFilterChange(
                                                            index,
                                                            "end_date",
                                                            newValue ? newValue.format("YYYY-MM-DD") : null
                                                            )
                                                        }
                                                        />
                                                </LocalizationProvider>}
                                            </Box>
                                        ) :(
                                            <input
                                                className='value_inputfilter mb-2'
                                                placeholder='Value'
                                                label="Value"
                                                value={filter.value}
                                                onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
                                            />
                                        )}</>}
                                    <button className='filterremovebtn mb-2 ms-0' onClick={() => removeFilter(index)}>Remove</button>
                                </Box>
                            ))}
                            <button className='registersendbtn1 mt-2 mb-0' onClick={addFilter}>Add Filter</button>
                            <button className='registersendbtn2 mt-2 mb-0 ms-3' onClick={handleSearchTable}>
                                {loadingApply ? <img src={require('../../../assets/whiteloader.gif')} alt=''/> : 'Apply'}
                            </button>
                        </Box>)}
                        <Grid size={{xs:12}} container justifyContent="space-between">
                            <div className='d-flex w-100 justify-content-between gap-3'>
                                <button className='show_filterbtn' onClick={toggleGrid}>
                                    {isGridVisible ?<> Hide Filter <FontAwesomeIcon icon={faFilterCircleXmark} /> </> :<> Show Filter <FontAwesomeIcon icon={faFilter} /> </>}
                                </button>
                                <select className='pink_rownded_select ' value={selectedCase} onChange={(e) => {setSelectCase(e.target.value); setLoading(true); setCurrentPage(1)}}>
                                    <option value="general">General Case</option>
                                    <option value="onboarding">Onboarding Case</option>
                                </select>
                            </div>
                        </Grid>
                    </Box>
                    {loadingPage ? 
                    <div className='d-flex justify-content-center w-100'>
                        <img style={{ width: "100px" }} src={require('../../../assets/pinkloader.gif')} alt='Loading...' />
                    </div> :<>
                    {(myrequests && myrequests.length === 0) ?
                    <span className='w-100 text-center'>No Data</span> :
                    <Box sx={{ height: 650, width: '100%' }} className="datatable_jobpagi select_searchindex">
                        <DataGrid
                            style={{minHeight:"200px"}}
                            rows={rows}
                            columns={columns}
                            // pageSize={pageSize}
                            disableSelectionOnClick
                            components={{ Toolbar: GridToolbar }}
                        />
                        <Grid size={{xs:12}} container justifyContent="space-between">
                            <div className='d-flex justify-content-end align-items-center mt-3'>
                                <label className='me-2'>Showing records <b>{paginatedata.from}</b>-<b>{paginatedata.to}</b> out of <b>{paginatedata.total}</b></label>
                            </div>
                            <div className='d-flex justify-content-end align-items-center mt-3'>
                                <label className='me-2'>No. of Rows</label>
                                <select
                                    label="Rows per page"
                                    value={selectedRecord || 20}
                                    onChange={(e) => {
                                        const value = Number(e.target.value);
                                        setShowRecord(value);
                                        setCurrentPage(1);
                                        fetchRoots({ per_page: value, filters: applyFilData });
                                    }}
                                    sx={{ mr: 2 }}
                                >
                                    {[5, 10, 20, 50].map((size) => (
                                        <option key={size} value={size}>{size}</option>
                                    ))}
                                </select>
                            </div>
                        </Grid>
                        <Grid size={{xs:12}} container justifyContent="center" className="mt-4 pagination_btn">
                            <button className='arrowpaginate'
                                onClick={() => handlePageChange(currentPage - 1)} 
                                disabled={currentPage === 1}>
                                <FontAwesomeIcon icon={faChevronLeft} />
                            </button>
                            {paginatedata && paginatedata.last_page > 0 && (
                                <div className="pagination">
                                    {(() => {
                                    const totalPages = Math.max(1, paginatedata.last_page);
                                    const pages = [];

                                    const start = Math.max(2, currentPage - 2);
                                    const end = Math.min(totalPages - 1, currentPage + 2);

                                    // Always show page 1
                                    pages.push(
                                        <button
                                        key={1}
                                        onClick={() => handlePageChange(1)}
                                        className={currentPage === 1 ? 'active' : ''}
                                        >
                                        1
                                        </button>
                                    );

                                    // Ellipsis after page 1 if needed
                                    if (start > 2) {
                                        pages.push(<span key="start-ellipsis">...</span>);
                                    }

                                    // Middle pages
                                    for (let i = start; i <= end; i++) {
                                        pages.push(
                                        <button
                                            key={i}
                                            onClick={() => handlePageChange(i)}
                                            className={currentPage === i ? 'active' : ''}
                                        >
                                            {i}
                                        </button>
                                        );
                                    }

                                    // Ellipsis before last page if needed
                                    if (end < totalPages - 1) {
                                        pages.push(<span key="end-ellipsis">...</span>);
                                    }

                                    // Always show last page (if more than 1)
                                    if (totalPages > 1) {
                                        pages.push(
                                        <button
                                            key={totalPages}
                                            onClick={() => handlePageChange(totalPages)}
                                            className={currentPage === totalPages ? 'active' : ''}
                                        >
                                            {totalPages}
                                        </button>
                                        );
                                    }

                                    return pages;
                                    })()}
                                </div>
                            )}
                            <button className='arrowpaginate'
                                onClick={() => handlePageChange(currentPage + 1)} 
                                disabled={currentPage === paginatedata.last_page}>
                                <FontAwesomeIcon icon={faChevronRight} />
                            </button>
                        </Grid>
                    </Box>
                    }</>}
                </>}
            </Grid>
            <Modal size='lg' centered show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                <Modal.Title>Short Description</Modal.Title>
                </Modal.Header>
                <Modal.Body className='mb-3 wrap_textnotflow'>{modalData}</Modal.Body>
            </Modal>
        </div>
    </div>
  )
}

export default RaisedCasesSeekers
